import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 800;

export const useWindowSize = (): number => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowWidth;
};

export const useIsMobile = (): boolean => {
  const width = useWindowSize();
  return width < MOBILE_BREAKPOINT;
};
